/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInProfileViewStepPriority } from './linkedInProfileViewStepPriority';
import type { LinkedInProfileViewStepTaskNoteDoc } from './linkedInProfileViewStepTaskNoteDoc';
import type { StepScheduleDelay } from './stepScheduleDelay';
import type { StepScheduleImmediate } from './stepScheduleImmediate';
import type { StepScheduleSoonestAt } from './stepScheduleSoonestAt';

export interface LinkedInProfileViewStep {
  schedule: StepScheduleImmediate | StepScheduleSoonestAt | StepScheduleDelay;
  priority?: LinkedInProfileViewStepPriority;
  type: 'linkedin_profile_view';
  task_note_doc?: LinkedInProfileViewStepTaskNoteDoc;
}
